import {InputTypes} from "../InputTypes";
import {OptionsSources} from "../OptionsSources";

export const UserDiet = Object.freeze({
    _id: {
        visibleName: "Id",
        hidden: true,
        type: InputTypes.TEXT,
    },
    name: {
        visibleName: "Nombre",
        type: InputTypes.TEXT,
    },
    active: {
        visibleName: "Activa",
        type: InputTypes.SELECT,
        optionsMapping: {
            source: OptionsSources.BOOLEAN
        }
    },
    diet_type: {
        visibleName: "Tipo",
        type: InputTypes.SELECT,
        optionsMapping: {
            source: OptionsSources.LEGEND
        }
    },
    toString: "Diet"
})

export const SpecificUserDiet = (userId)=>{
    let specificDiet = JSON.parse(JSON.stringify(UserDiet));
    specificDiet.user_id = userId;
    specificDiet.toString = "Diet " + userId;
    return specificDiet;
}
